// Which site this build is (#219). One codebase, two builds: the full game
// (`vite build`, the owner's site, kickflip-909.pages.dev) and Bomb the Hill
// on its own (`vite build --mode hill`, `build:hill`, the public site). Vite
// writes `import.meta.env.MODE` in as a string, so in the full build every
// `HILL_SITE` branch is dead code and in the hill build every park-only one
// is: the park maps, their thumbnails, the demo lines and the release notes
// aren't in the hill's bundle at all (`scripts/check-hill.mjs` checks).
// Tests run in mode "test", the full game.

export const HILL_SITE: boolean = import.meta.env.MODE === "hill";
